import _ from 'lodash';
export const searchAndFilterNeeds = ({ sortField, sortAsc, items, searchTerm, }) => {
    function filter(_allItems, _searchTerm) {
        if (!searchTerm) {
            return items;
        }
        return _.filter(_allItems, (item) => {
            return (item.data.title &&
                item.data.title.toLowerCase().includes(_searchTerm.toLowerCase()));
        });
    }
    function sort(_sortField, _sortAsc, _items) {
        return _.orderBy(_items, _sortField, _sortAsc ? 'asc' : 'desc');
    }
    return sort(sortField, sortAsc, filter(items, searchTerm));
};
